export const BackgroundColor = {
    name: 'background-color',
    config: {
        options: {
            backgroundColorSwapping: false
        }
    },
    subscribeToEvents
}

function subscribeToEvents() {
    this.bus.events.slideChange.subscribe(slideChange.bind(this))
}

function slideChange() {
    if (!this.config.options.backgroundColorSwapping) {
        return
    }

    const currentSlide = this.elements.slides[this.state.currentSlide]
    const currentColor = currentSlide.dataset.background
    if (currentColor) {
        this.elements.container.style.setProperty('--background-color', `var(${currentColor})`)
    }
}
